const PRICE_PER_STYLIST = Object.freeze({
  essentialOldPrice: '10',
  essentialNewPrice: '12',
  advOldPrice: '15',
  advNewPrice: '18',
});

export default PRICE_PER_STYLIST;
